import { createRoot } from 'react-dom/client';

import { RequestManagerProvider } from './shared/providers/RequestManagerProvider';
import { HomeAppProvider } from './shared/providers/HomeAppProvider';
import { HOME_BASENAME } from './shared/routing/HomeRoutes';
import { RM_BASENAME } from './shared/routing/RequestManagerRoutes';

const matchBasename = (pathname: string, basename: string) =>
    pathname === basename || pathname.startsWith(`${basename}/`);

const resolveApp = (pathname: string) => {
    if (matchBasename(pathname, HOME_BASENAME)) return <HomeAppProvider />;
    if (matchBasename(pathname, RM_BASENAME)) return <RequestManagerProvider />;
};

const renderApp = () => {
    const app = resolveApp(window.location.pathname);
    if (app === undefined) {
        // Pathname matches neither HOME_BASENAME nor RM_BASENAME — those are the only two apps
        // registered in this entry point, so all legitimate internal routes are already covered
        // by matchBasename above. This only fires for truly external paths (e.g. the bare PR
        // preview base URL "/" or an unconfigured hostname root).
        window.location.replace(`${RM_BASENAME}/`);
        return;
    }
    const root = createRoot(document.getElementById('app') as HTMLElement);
    root.render(app);
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderApp);
} else {
    renderApp();
}
